import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

const HeaderContainer = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  background-color: white;
  border: 1px solid rgba(31, 43, 55, 0.1);
  border-bottom: 2px solid ${(props) => props.theme.colors['terra-cotta']};
  color: #1e3647;
  align-items: center;
  letter-spacing: normal;
  text-transform: uppercase;
  font-size: 12px;
  white-space: nowrap;

  @media (max-width: 845px) {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
  }
`;

const TooltipContent = styled.div`
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  > div {
    margin-right: 10px;
  }
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${(props) => props.length};
  justify-content: ${(props) => (props.center ? 'center' : 'flex-start')};
  padding-left: ${(props) => (props.padding ? props.padding : 0)};
  height: 100%;
  :not(:last-child) {
    border-right: ${(props) =>
      props.noBorder ? 0 : '1px solid rgba(31, 43, 55, 0.1)'};
  }

  p {
    font-family: ${(props) => props.theme.fonts.oswald};
    margin-left: ${(props) => (props.center ? null : '20px')};
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .listHeaderSort {
    margin: 0 6px;
  }

  .listHeaderSort:hover {
    cursor: pointer;
  }
`;

const Header = ({ columns }) => {
  return (
    <HeaderContainer>
      {columns.map((column) => (
        <ColumnContainer
          length={column.length}
          center={column.center}
          padding={column.padding}
          noBorder={column.noBorder}
          key={`${column.name}-${column.length}`}
        >
          <p>{column.name}</p>
          {column.tooltip && (
            <TooltipContent>
              <Tooltip
                iconColor="#aaa"
                placement={column.tooltip.placement}
                content={<p>{column.tooltip.content}</p>}
              />
            </TooltipContent>
          )}
          {column.sort && (
            <div className="listHeaderSort" onClick={() => column.onSort()}>
              <Icon icon="sort" />
            </div>
          )}
        </ColumnContainer>
      ))}
    </HeaderContainer>
  );
};

export default Header;
